import { Component, OnInit } from '@angular/core';
import { FracStatRow, KPIDashboardService } from '~lmo/kpidashboard/kpidashboard.service';

@Component({
  selector: 'sa-fracs-stats',
  styleUrls: ['./fracs-stats.component.scss'],
  templateUrl: './fracs-stats.component.html',
})
export class FracsStatsComponent implements OnInit {
  public regionID: number;
  public fracsID: number[];
  public dataSource: FracStatRow[] = [];
  public displayedColumns: string[] = [
    'fracID',
    'fracName',
    'waitTime',
    'currentStage',
    'totalStages',
    'trucksOnLocation',
    'loadsInProgress',
    'plannedPumpAmount',
    'actualPumpedAmount',
    'percentageDifference',
  ];

  constructor(private kpiDashboardService: KPIDashboardService) {}

  public ngOnInit(): void {
    this.subscribeToRegionID();
    this.subscribeToFracID();
  }

  private subscribeToRegionID(): void {
    this.kpiDashboardService.regionID$.subscribe((regionID) => {
      this.resetDataSource();
      this.regionID = regionID;
      this.fetchFracStats(regionID, []);
    });
  }

  private subscribeToFracID(): void {
    this.kpiDashboardService.fracsID$.subscribe((fracsID) => {
      if (fracsID.length > 0) {
        this.resetDataSource();
        this.fracsID = fracsID;
        this.fetchFracStats(this.regionID, this.fracsID);
      } else {
        this.resetDataSource();
        this.fetchFracStats(this.regionID, []);
      }
    });
  }

  private fetchFracStats(regionID: number, fracsID: number[]): void {
    this.kpiDashboardService.getFracsStats$(regionID, fracsID).subscribe({
      error: () => this.resetDataSource(),
      next: (data) => (this.dataSource = data),
    });
  }

  private resetDataSource(): void {
    this.dataSource = [];
  }

  public calculatePercentage(value1: number, value2: number): number {
    if (!value2 || value2 === 0) {
      return 0;
    }
    return (value1 / value2) * 100;
  }
}
